import React, { useEffect, useState } from "react";
import { useCountryStateCityProvider } from "../../../../../Providers/Common/CountyStateCity";

export default function Sidebar({ details }) {
  const { getStatesByCountry, getCountries } =
    useCountryStateCityProvider();
  const location = details?.location ? details.location + ", " : "";
  const city = details?.city ? details.city + ", " : "";
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  useEffect(() => {
    if (details.state && details.country) {
      getStatesByCountry(details.country, details.state).then((res) =>
        setState(res.name)
      );
    }
    if (details.country) {
      console.log(details.country)
      getCountries(details.country).then((res) => {
        console.log(res)
        setCountry(res.name)
      });
    }
  }, [details]);
  // useEffect(() => {
  //   async function getAddress() {
  //     const state = details?.state
  //       ? (await getStatesByCountry(details.country, details.state)
  //           .name) + ", "
  //       : "";
  //     const country = details?.country
  //       ? (await getCountries(details.country).name) + " "
  //       : "";
  //     setState(state);
  //     setCountry(country);
  //   }
  //   getAddress();
  // }, []);

  return (
    <div className="flex flex-col space-y-8">
      <div className="flex lg:w-full rounded-lg flex-col space-y-4 lg:mt-0 mt-8 lg:mx-4 py-4 px-8 bg-white h-min">
        <div className="flex justify-start items-center space-x-4">
          <span className="flex flex-col">
            <span className="text-xl">Contact Executive</span>
            <div className="flex flex-col">
              <span className="mt-1 ml-4">
                {details?.firstName && details?.lastName
                  ? details.firstName + " " + details?.lastName
                  : details?.firstName}
              </span>
              <span className="mt-1 ml-4">
                {details?.phone ? details.phone : "No Phone Number Provided"}
              </span>
            </div>
          </span>
        </div>
        <div className="text-xl">Email Us</div>
        <div className="flex justify-start items-center space-x-4 ml-4">
          <div className="flex flex-row space-x-4 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"
              />
            </svg>
            <span>
              {details?.email != null ? details?.email : "Email Not Provided"}
            </span>
          </div>
        </div>
        <div className="flex justify-start items-center space-x-4 ml-4">
          <div className="flex flex-row items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                stroke-linejoin="round"
                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
              />
            </svg>
            <span>
              {location}
              {city}
              {state}
              {", "}
              {country}
              {(details?.location == null ||
                details?.location == " " ||
                details?.location == "") &&
                (details?.state == null ||
                  details?.state == " " ||
                  details?.state == "") &&
                (details?.country == null ||
                  details?.country == " " ||
                  details?.country == "") &&
                "No Location Provided"}
            </span>
          </div>
        </div>
        <div className="flex justify-start items-center space-x-4 ml-4">
          <div className="flex flex-row items-center space-x-4">
            {details.linkedin && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    stroke-linejoin="round"
                    d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                  />
                </svg>

                <a
                  target="_blank"
                  className="text-blue-500"
                  href={
                    details?.linkedin &&
                      details?.linkedin.split(":")[0] === "https"
                      ? details?.linkedin
                      : "https://" + details?.linkedin
                  }
                >
                  {details?.linkedin
                    ? details.linkedin
                    : "No LinkedIn Provided"}
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
